import { useNode } from "@craftjs/core";
import React from "react";

import {
  ColorInput,
  UnitInput,
  BoxShadowInput,
  PaddingInput,
  Panel,
  Tabs,
  TextInput,
  BorderRadiusInput,
  BorderInput,
  AlignInput,
  ToggleInput,
  MarginInput,
  SelectInput,
  TabsV2,
  RangeNumberInput,
} from "../../input";
import { changeTransition, isUpdatedFromDefault } from "../../utils";

import { supportLibrary } from "../../block-supports";

export const FormSubmitSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));

  const {
    containerWidth,
    containerWidthTablet,
    containerWidthMobile,
    containerHeight,
    containerHeightTablet,
    containerHeightMobile,
    containerMaxWidth,
    containerMaxHeight,
    buttonWidth,
    buttonWidthTablet,
    buttonWidthMobile,
    buttonHeight,
    buttonHeightTablet,
    buttonHeightMobile,
    buttonMaxWidth,
    buttonMaxHeight,
    align,
    alignTablet,
    alignMobile,
    buttonAlign,
    buttonAlignTablet,
    buttonAlignMobile,
    buttonColor,
    buttonBackgroundColor,
    containerBackgroundColor,
    containerPadding,
    containerPaddingTablet,
    containerPaddingMobile,
    containerBorder,
    containerBorderRadius,
    containerBoxShadow,
    containerMargin,
    containerMarginTablet,
    containerMarginMobile,
    buttonMargin,
    buttonMarginTablet,
    buttonMarginMobile,
    buttonPadding,
    buttonPaddingTablet,
    buttonPaddingMobile,
    buttonBorder,
    buttonBorderRadius,
    buttonBoxShadow,
    typoSize,
    hoverButtonColor,
    hoverButtonBackgroundColor,
    hoverContainerBackgroundColor,
    hoverContainerPadding,
    hoverContainerPaddingTablet,
    hoverContainerPaddingMobile,
    hoverContainerBorder,
    hoverContainerBorderRadius,
    hoverContainerBoxShadow,
    hoverContainerMargin,
    hoverContainerMarginTablet,
    hoverContainerMarginMobile,
    hoverButtonMargin,
    hoverButtonMarginTablet,
    hoverButtonMarginMobile,
    hoverButtonPadding,
    hoverButtonPaddingTablet,
    hoverButtonPaddingMobile,
    hoverButtonBorder,
    hoverButtonBorderRadius,
    hoverButtonBoxShadow,
    transition,
  } = props;

  function GeneralSettings() {
    return (
      <div className="g-settings__wrapper">
        <Panel
          isUpdated={isUpdatedFromDefault([{ key: typoSize }])}
          id={`block-setting-${id}-button`}
          title={"Button"}
          initialOpen={true}
        >
          <UnitInput
            resetValue={undefined}
            value={typoSize}
            onChange={(val) => {
              setProp((props) => {
                props.typoSize = val;
              });
            }}
            label={"Font Size"}
          />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: buttonAlignTablet },
            { key: buttonAlignMobile },
            { key: buttonAlign },
            { key: buttonWidth },
            { key: buttonWidthMobile },
            { key: buttonWidthTablet },
            { key: buttonHeight },
            { key: buttonHeightMobile },
            { key: buttonHeightTablet },
            { key: buttonMaxWidth },
            { key: buttonMaxHeight },
          ])}
          id={`block-setting-${id}-button`}
          title={"Button"}
          initialOpen={true}
        >
          <AlignInput
            isResponsive={true}
            resetValue={undefined}
            valueTablet={buttonAlignTablet}
            valueMobile={buttonAlignMobile}
            value={buttonAlign}
            onChange={(val) => {
              setProp((props) => {
                props.buttonAlign = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.buttonAlignTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.buttonAlignMobile = val;
              });
            }}
            label={"Align"}
          />
          <UnitInput
            isResponsive={true}
            resetValue={undefined}
            value={buttonWidth}
            valueMobile={buttonWidthMobile}
            valueTablet={buttonWidthTablet}
            onChange={(val) => {
              setProp((props) => {
                props.buttonWidth = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.buttonWidthTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.buttonWidthMobile = val;
              });
            }}
            label={"Width"}
          />
          <UnitInput
            isResponsive={true}
            resetValue={undefined}
            value={buttonHeight}
            valueMobile={buttonHeightMobile}
            valueTablet={buttonHeightTablet}
            onChange={(val) => {
              setProp((props) => {
                props.buttonHeight = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.buttonHeightTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.buttonHeightMobile = val;
              });
            }}
            label={"Height"}
          />
          <UnitInput
            value={buttonMaxWidth}
            onChange={(val) => {
              setProp((props) => {
                props.buttonMaxWidth = val;
              });
            }}
            label={"Max Width"}
          />
          <UnitInput
            resetValue={undefined}
            value={buttonMaxHeight}
            onChange={(val) => {
              setProp((props) => {
                props.buttonMaxHeight = val;
              });
            }}
            label={"Max Height"}
          />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: alignTablet },
            { key: alignMobile },
            { key: align },
            { key: containerWidth },
            { key: containerWidthMobile },
            { key: containerWidthTablet },
            { key: containerHeight },
            { key: containerHeightMobile },
            { key: containerHeightTablet },
            { key: containerMaxWidth },
            { key: containerMaxHeight },
          ])}
          id={`block-setting-${id}-container`}
          title={"Container"}
          initialOpen={false}
        >
          <AlignInput
            isResponsive={true}
            resetValue={undefined}
            valueTablet={alignTablet}
            valueMobile={alignMobile}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.alignTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.alignMobile = val;
              });
            }}
            label={"Align"}
          />
          <UnitInput
            isResponsive={true}
            resetValue={undefined}
            value={containerWidth}
            valueMobile={containerWidthMobile}
            valueTablet={containerWidthTablet}
            onChange={(val) => {
              setProp((props) => {
                props.containerWidth = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.containerWidthTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.containerWidthMobile = val;
              });
            }}
            label={"Width"}
          />
          <UnitInput
            isResponsive={true}
            resetValue={undefined}
            value={containerHeight}
            valueMobile={containerHeightMobile}
            valueTablet={containerHeightTablet}
            onChange={(val) => {
              setProp((props) => {
                props.containerHeight = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.containerHeightTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.containerHeightMobile = val;
              });
            }}
            label={"Height"}
          />
          <UnitInput
            value={containerMaxWidth}
            onChange={(val) => {
              setProp((props) => {
                props.containerMaxWidth = val;
              });
            }}
            label={"Max Width"}
          />
          <UnitInput
            resetValue={undefined}
            value={containerMaxHeight}
            onChange={(val) => {
              setProp((props) => {
                props.containerMaxHeight = val;
              });
            }}
            label={"Max Height"}
          />
        </Panel>
      </div>
    );
  }

  function StyleSettings() {
    const colorTabs = [
      {
        label: "Normal",
        key: "normal",
        children: normalColorSettings(),
      },
      {
        label: "Hover",
        key: "hover",
        children: hoverColorSettings(),
      },
    ];
    function normalColorSettings(params) {
      return (
        <>
          {" "}
          <ColorInput
            value={buttonBackgroundColor}
            onChange={(val) => {
              setProp((props) => {
                props.buttonBackgroundColor = val;
              });
            }}
            label={"Background"}
          />
          <ColorInput
            value={buttonColor}
            onChange={(val) => {
              setProp((props) => {
                props.buttonColor = val;
              });
            }}
            label={"Color"}
          />
        </>
      );
    }

    function hoverColorSettings(params) {
      return (
        <>
          {" "}
          <ColorInput
            value={hoverButtonBackgroundColor}
            onChange={(val) => {
              setProp((props) => {
                props.hoverButtonBackgroundColor = val;
              });
            }}
            label={"Background"}
          />
          <ColorInput
            value={hoverButtonColor}
            onChange={(val) => {
              setProp((props) => {
                props.hoverButtonColor = val;
              });
            }}
            label={"Color"}
          />
          <RangeNumberInput
            min={0}
            max={10}
            step={0.05}
            value={transition?.types?.["color"]?.duration}
            onChange={(val) => {
              changeTransition(
                ["color", "background-color"],
                { duration: val },
                transition,
                setProp,
              );
            }}
            label={"Transition Time"}
          />
        </>
      );
    }
    const containerColorTabs = [
      {
        label: "Normal",
        key: "normal",
        children: normalContainerColorSettings(),
      },
      {
        label: "Hover",
        key: "hover",
        children: hoverContainerColorSettings(),
      },
    ];
    function normalContainerColorSettings(params) {
      return (
        <>
          {" "}
          <ColorInput
            value={containerBackgroundColor}
            onChange={(val) => {
              setProp((props) => {
                props.containerBackgroundColor = val;
              });
            }}
            label={"Background"}
          />
        </>
      );
    }

    function hoverContainerColorSettings(params) {
      return (
        <>
          {" "}
          <ColorInput
            value={hoverContainerBackgroundColor}
            onChange={(val) => {
              setProp((props) => {
                props.hoverContainerBackgroundColor = val;
              });
            }}
            label={"Background"}
          />
          <RangeNumberInput
            min={0}
            max={10}
            step={0.05}
            value={transition?.types?.["color"]?.duration}
            onChange={(val) => {
              changeTransition(
                ["background-color"],
                { duration: val },
                transition,
                setProp,
              );
            }}
            label={"Transition Time"}
          />
        </>
      );
    }
    return (
      <>
        <div className="g-settings__wrapper">
          <Panel
            isUpdated={isUpdatedFromDefault([
              { key: buttonBackgroundColor },
              { key: buttonColor },
              { key: hoverButtonBackgroundColor },
              { key: hoverButtonColor },
              { key: hoverContainerBackgroundColor },
            ])}
            id={`block-setting-${id}-button`}
            title={"Button"}
            initialOpen={true}
          >
            <TabsV2 items={colorTabs} />
          </Panel>
          <Panel
            isUpdated={isUpdatedFromDefault([
              { key: containerBackgroundColor },
            ])}
            id={`block-setting-${id}-container`}
            title={"Container"}
          >
            <TabsV2 items={containerColorTabs} />
          </Panel>
        </div>
      </>
    );
  }

  function AdvancedSettings() {
    const buttonTabs = [
      {
        label: "Normal",
        key: "normal",
        children: normalButtonSettings(),
      },
      {
        label: "Hover",
        key: "hover",
        children: hoverButtonSettings(),
      },
    ];
    function normalButtonSettings() {
      return (
        <>
          {" "}
          <MarginInput
            label={"Margin"}
            isResponsive={true}
            valueTablet={buttonMarginTablet}
            valueMobile={buttonMarginMobile}
            value={buttonMargin}
            onChange={(val) => {
              setProp((props) => {
                props.buttonMargin = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.buttonMarginTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.buttonMarginMobile = val;
              });
            }}
          />
          <PaddingInput
            label={"Padding"}
            isResponsive={true}
            valueTablet={buttonPaddingTablet}
            valueMobile={buttonPaddingMobile}
            value={buttonPadding}
            onChange={(val) => {
              setProp((props) => {
                props.buttonPadding = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.buttonPaddingTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.buttonPaddingMobile = val;
              });
            }}
          />
          <BorderInput
            resetValue={undefined}
            value={buttonBorder}
            onChange={(val) => {
              setProp((props) => {
                props.buttonBorder = val;
              });
            }}
            label={"Border"}
          />
          <BorderRadiusInput
            resetValue={undefined}
            value={buttonBorderRadius}
            onChange={(val) => {
              setProp((props) => {
                props.buttonBorderRadius = val;
              });
            }}
            label={"Border Radius"}
          />
          <BoxShadowInput
            resetValue={undefined}
            value={buttonBoxShadow}
            onChange={(val) => {
              setProp((props) => {
                props.buttonBoxShadow = val;
              });
            }}
          />
        </>
      );
    }
    function hoverButtonSettings() {
      return (
        <>
          <MarginInput
            label={"Margin"}
            isResponsive={true}
            valueTablet={hoverButtonMarginTablet}
            valueMobile={hoverButtonMarginMobile}
            value={hoverButtonMargin}
            onChange={(val) => {
              setProp((props) => {
                props.hoverButtonMargin = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.hoverButtonMarginTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.hoverButtonMarginMobile = val;
              });
            }}
          />
          <PaddingInput
            label={"Padding"}
            isResponsive={true}
            valueTablet={hoverButtonPaddingTablet}
            valueMobile={hoverButtonPaddingMobile}
            value={hoverButtonPadding}
            onChange={(val) => {
              setProp((props) => {
                props.hoverButtonPadding = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.hoverButtonPaddingTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.hoverButtonPaddingMobile = val;
              });
            }}
          />
          <BorderInput
            resetValue={undefined}
            value={hoverButtonBorder}
            onChange={(val) => {
              setProp((props) => {
                props.hoverButtonBorder = val;
              });
            }}
            label={"Border"}
          />
          <BorderRadiusInput
            resetValue={undefined}
            value={hoverButtonBorderRadius}
            onChange={(val) => {
              setProp((props) => {
                props.hoverButtonBorderRadius = val;
              });
            }}
            label={"Border Radius"}
          />
          <BoxShadowInput
            resetValue={undefined}
            value={hoverButtonBoxShadow}
            onChange={(val) => {
              setProp((props) => {
                props.hoverButtonBoxShadow = val;
              });
            }}
          />

          <RangeNumberInput
            min={0}
            max={10}
            step={0.05}
            value={
              transition?.types?.[
                ("border", "border-radius", "margin", "padding", "box-shadow")
              ]?.duration
            }
            onChange={(val) => {
              changeTransition(
                ["border", "border-radius", "margin", "padding", "box-shadow"],
                { duration: val },
                transition,
                setProp,
              );
            }}
            label={"Transition Time"}
          />
        </>
      );
    }
    const containerTabs = [
      {
        label: "Normal",
        key: "normal",
        children: normalContainerSettings(),
      },
      {
        label: "Hover",
        key: "hover",
        children: hoverContainerSettings(),
      },
    ];
    function normalContainerSettings() {
      return (
        <>
          {" "}
          <MarginInput
            label={"Margin"}
            isResponsive={true}
            valueTablet={containerMarginTablet}
            valueMobile={containerMarginMobile}
            value={containerMargin}
            onChange={(val) => {
              setProp((props) => {
                props.containerMargin = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.containerMarginTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.containerMarginMobile = val;
              });
            }}
          />
          <PaddingInput
            label={"Padding"}
            isResponsive={true}
            valueTablet={containerPaddingTablet}
            valueMobile={containerPaddingMobile}
            value={containerPadding}
            onChange={(val) => {
              setProp((props) => {
                props.containerPadding = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.containerPaddingTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.containerPaddingMobile = val;
              });
            }}
          />
          <BorderInput
            resetValue={undefined}
            value={containerBorder}
            onChange={(val) => {
              setProp((props) => {
                props.containerBorder = val;
              });
            }}
            label={"Border"}
          />
          <BorderRadiusInput
            resetValue={undefined}
            value={containerBorderRadius}
            onChange={(val) => {
              setProp((props) => {
                props.containerBorderRadius = val;
              });
            }}
            label={"Border Radius"}
          />
          <BoxShadowInput
            resetValue={undefined}
            value={containerBoxShadow}
            onChange={(val) => {
              setProp((props) => {
                props.containerBoxShadow = val;
              });
            }}
          />
        </>
      );
    }
    function hoverContainerSettings() {
      return (
        <>
          {" "}
          <MarginInput
            label={"Margin"}
            isResponsive={true}
            valueTablet={hoverContainerMarginTablet}
            valueMobile={hoverContainerMarginMobile}
            value={hoverContainerMargin}
            onChange={(val) => {
              setProp((props) => {
                props.hoverContainerMargin = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.hoverContainerMarginTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.hoverContainerMarginMobile = val;
              });
            }}
          />
          <PaddingInput
            label={"Padding"}
            isResponsive={true}
            valueTablet={hoverContainerPaddingTablet}
            valueMobile={hoverContainerPaddingMobile}
            value={hoverContainerPadding}
            onChange={(val) => {
              setProp((props) => {
                props.hoverContainerPadding = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.hoverContainerPaddingTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.hoverContainerPaddingMobile = val;
              });
            }}
          />
          <BorderInput
            resetValue={undefined}
            value={hoverContainerBorder}
            onChange={(val) => {
              setProp((props) => {
                props.hoverContainerBorder = val;
              });
            }}
            label={"Border"}
          />
          <BorderRadiusInput
            resetValue={undefined}
            value={hoverContainerBorderRadius}
            onChange={(val) => {
              setProp((props) => {
                props.hoverContainerBorderRadius = val;
              });
            }}
            label={"Border Radius"}
          />
          <BoxShadowInput
            resetValue={undefined}
            value={hoverContainerBoxShadow}
            onChange={(val) => {
              setProp((props) => {
                props.hoverContainerBoxShadow = val;
              });
            }}
          />
          <RangeNumberInput
            min={0}
            max={10}
            step={0.05}
            value={
              transition?.types?.[
                ("margin", "padding", "border", "border-radius", "box-shadow")
              ]?.duration
            }
            onChange={(val) => {
              changeTransition(
                ["margin", "padding", "border", "border-radius", "box-shadow"],
                { duration: val },
                transition,
                setProp,
              );
            }}
            label={"Transition Time"}
          />
        </>
      );
    }
    return (
      <>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: buttonMarginTablet },
            { key: buttonMarginMobile },
            { key: buttonMargin },
            { key: buttonPaddingTablet },
            { key: buttonPaddingMobile },
            { key: buttonPadding },
            { key: buttonBorder },
            { key: buttonBorderRadius },
            { key: buttonBoxShadow },
          ])}
          id={`block-setting-${id}-button`}
          title={"Button"}
          initialOpen={true}
        >
          <TabsV2 items={buttonTabs} />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: containerMarginTablet },
            { key: containerMarginMobile },
            { key: containerMargin },
            { key: containerPaddingTablet },
            { key: containerPaddingMobile },
            { key: containerPadding },
            { key: containerBorder },
            { key: containerBorderRadius },
            { key: containerBoxShadow },
            { key: hoverContainerMarginTablet },
            { key: hoverContainerMarginMobile },
            { key: hoverContainerMargin },
            { key: hoverContainerPaddingTablet },
            { key: hoverContainerPaddingMobile },
            { key: hoverContainerPadding },
            { key: hoverContainerBorder },
            { key: hoverContainerBorderRadius },
            { key: hoverContainerBoxShadow },
          ])}
          id={`block-setting-${id}-container`}
          title={"Container"}
          initialOpen={false}
        >
          <TabsV2 items={containerTabs} />
        </Panel>

        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </>
    );
  }
  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: typoSize },
        { key: buttonAlignTablet },
        { key: buttonAlignMobile },
        { key: buttonAlign },
        { key: buttonWidth },
        { key: buttonWidthMobile },
        { key: buttonWidthTablet },
        { key: buttonHeight },
        { key: buttonHeightMobile },
        { key: buttonHeightTablet },
        { key: buttonMaxWidth },
        { key: buttonMaxHeight },
        { key: alignTablet },
        { key: alignMobile },
        { key: align },
        { key: containerWidth },
        { key: containerWidthMobile },
        { key: containerWidthTablet },
        { key: containerHeight },
        { key: containerHeightMobile },
        { key: containerHeightTablet },
        { key: containerMaxWidth },
        { key: containerMaxHeight },
      ]),
    },
    {
      label: "Style",
      key: "style",
      children: StyleSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: buttonBackgroundColor },
        { key: containerBackgroundColor },
        { key: buttonColor },
        { key: hoverButtonBackgroundColor },
        { key: hoverButtonColor },
        { key: hoverContainerBackgroundColor },
      ]),
    },
    {
      label: "Advanced",
      key: "advanced",
      children: AdvancedSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: buttonMarginTablet },
        { key: buttonMarginMobile },
        { key: buttonMargin },
        { key: buttonPaddingTablet },
        { key: buttonPaddingMobile },
        { key: buttonPadding },
        { key: buttonBorder },
        { key: buttonBorderRadius },
        { key: buttonBoxShadow },
        { key: containerMarginTablet },
        { key: containerMarginMobile },
        { key: containerMargin },
        { key: containerPaddingTablet },
        { key: containerPaddingMobile },
        { key: containerPadding },
        { key: containerBorder },
        { key: containerBorderRadius },
        { key: containerBoxShadow },
        { key: hoverContainerMarginTablet },
        { key: hoverContainerMarginMobile },
        { key: hoverContainerMargin },
        { key: hoverContainerPaddingTablet },
        { key: hoverContainerPaddingMobile },
        { key: hoverContainerPadding },
        { key: hoverContainerBorder },
        { key: hoverContainerBorderRadius },
        { key: hoverContainerBoxShadow },
      ]),
    },
  ];

  return (
    <div>
      <Tabs
        type="block-setting"
        id={`block-settings-tab-${id}`}
        items={tabs.map((item, i) => {
          return {
            label: item.label,
            key: item.key,
            children: item.children,
          };
        })}
      />
    </div>
  );
};
